import { GET_PROMOTIONAL_CARDS } from '.'
import { getFirstDashCampaignsById } from '../api/dasherPromotions'
import { trackPromotionsPage } from '../events'
import * as DA from '../typeModules/events'

/**
 * @param {string} uniqueLink - the Dasher Applicant unique link
 */
export const getPromotionalCards = (uniqueLink: string) => {
  return async dispatch => {
    dispatch({ type: GET_PROMOTIONAL_CARDS.IN_PROGRESS })

    try {
      const response = await getFirstDashCampaignsById(uniqueLink)

      dispatch(
        trackPromotionsPage(
          DA.EventActions.Success,
          DA.PromotionsPageNames.PromotionCampaigns
        )
      )
      dispatch({
        type: GET_PROMOTIONAL_CARDS.SUCCESS,
        payload: response.data,
      })

      return Promise.resolve()
    } catch (error) {
      dispatch(
        trackPromotionsPage(
          DA.EventActions.Error,
          DA.PromotionsPageNames.PromotionCampaigns,
          error.message
        )
      )
      dispatch({ type: GET_PROMOTIONAL_CARDS.FAIL })
      throw error
    }
  }
}
